import React from "react";
import PaymentsTable from "../../../components/doctor-side-components/payments-table/PaymentsTable";

const DoctorPaymentHistoryListing = () => {
  return (
    <div className="p-4">
      <PaymentsTable />
    </div>
  );
};

export default DoctorPaymentHistoryListing;
